import { apiClient } from "./axios";

/** Envelope de listagem paginada do launches-api (`PagedResponse<T>`). */
export interface PagedResponse<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
}

/**
 * Busca TODAS as páginas de um endpoint paginado e devolve a lista achatada.
 * Mantém a paginação/filtragem client-side existente funcionando no modo real
 * (o backend limita `pageSize` a 100/página). Para guardar contra respostas
 * inconsistentes, para após no máximo `total` itens ou uma página vazia.
 */
export async function fetchAllPaged<T>(
  path: string,
  params: Record<string, unknown> = {},
): Promise<T[]> {
  const out: T[] = [];
  let page = 1;

  for (;;) {
    const { data } = await apiClient.get<PagedResponse<T>>(path, {
      params: { ...params, page, pageSize: 100 },
    });
    out.push(...data.items);
    if (data.items.length === 0 || out.length >= data.total) break;
    page += 1;
  }

  return out;
}
